// import React,{useMemo,useState} from 'react';
import React, { useState, useEffect, useMemo } from "react";
import {useDeleteCategory, useDeleteMeasurementUnit, useGetAllCategoriesTenantId,useGetBank} from '../../Hooks/Index'
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom/DYCustom';
import {Grid, Box,Typography} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import AddMeasurementUnit from "../../../Settings/LComponents/AddMeasurementUnit/AddMeasurementUnit";
import EditMeasurementUnit from "../EditMeasurementUnit/EditMeasurementUnit";
import { useGetAllMeasurementUnitByTenantId1 } from "../../../IndexManaging/Hooks/Index";
const MeasurementUnit = () => {

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
   const {data:dataIndex,isLoading:dataLoading,isError:dataError,refetch:getAgain}=useGetAllMeasurementUnitByTenantId1(tenantId);
   const{mutate:deleteTeam,isError,isSuccess,data:deleteData}=useDeleteMeasurementUnit();
  const{data,metaData} : any = dataIndex  || {};
  const{appStatusCode}=metaData  || {};
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
    localStorage.getItem("indexSelectionModel")
  );

  useEffect(() => {
    if (addEvalAsyncData) {
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  useEffect(() => {
    const indexSelectionModel = localStorage.getItem("indexSelectionModel");
    if (indexSelectionModel) {
      setIndexSelectionModel(indexSelectionModel);
    }
  }, [addEvalAsyncData]);


  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 60,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
    
      { field: 'name',
        align:'left',
        headerName: 'شرح',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
        width: 170,
        flex:1
      },
  ],[]);
  const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [iuccess, SetIsSuccess] = useState(false);
  const [tMessage, SetTMessage] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [krId, setKrId] = useState(null);
    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const initialDelete=()=>{
    let deleteBody={
id:krId
}
deleteTeam(deleteBody)
}

useEffect(() => {
  if (deleteData) {
    if (deleteData?.data.isSuccess) {
      setShowToastMessage2(true);
      SetIsSuccess(true);
      SetTMessage(deleteData?.data.metaData.message);
    } else {
      setShowToastMessage2(true);
      SetIsSuccess(false);
      SetTMessage(deleteData?.data.metaData.message);
    }
  }
}, [deleteData]);


  const renderContent=()=>{
    if (dataLoading) {
      return (<Box  width={'100%'} py={16}   >
        <CircularProgress   />
      </Box>)
    }
    else if(appStatusCode === 7){
      return (<Box  width={'100%'} py={16}   >
         <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
         شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
    </Typography>
      </Box>)
    }
    else {
      return <>
       <DyDataGridCustom
     rowHeight={10}
     data={dataError || dataLoading ? []:data }
     columns={tenantsColumns || []}
     hideFooter={false}
     additionalToolbar={true}
     setSelectionModel={setIndexSelectionModel}
     setShowHistory={setHistoryModal}
     setSpecialId={setKrId}
     initialOnRowClick={setKrRowData}
     initialDelete={initialDelete}
     /></>
    }
  }
  const initialAddLicense = (): void => {
    setShowAddLicense((prev) => !prev);
  };


  return (
    <>
    <Grid  sx={{bgcolor:'#F9F9F9',minHeight:'300vh',width:'100% !important',padding:'0px !important'}}   >
     <Grid item xs={12}   >
     <div>
      <Box py={1} display={'flex'} justifyContent={'end'}>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense()
            }
            className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
               btn-sm rounded-md m-2`}
          >
            افزودن
          </button>
     </Box>
          <ModalLyt
            showModal={showAddLicense}
            setShowModal={setShowAddLicense}
            width={600}
            height={500}
            title={"معیار سنجش"}
          >
            <AddMeasurementUnit
              onSuccess={setShowAddLicense}
              setShowToastMessage={setShowToastMessage}
              onClose={setShowAddLicense}
            />
          </ModalLyt>
     </div>
     </Grid>
     <Grid item xs={12}   >
     <Box textAlign={'center'}  mx={1} borderRadius={2} boxShadow={2} bgcolor={'white'} my={1} py={dataLoading?8:3}   >
    {
      renderContent()
    }
     </Box>
     {historyModal && (
          <ModalLyt
            title={"ویرایش"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <EditMeasurementUnit
              krDetail={krRowData}
              setShowToastMessage = {setShowToastMessage}
              onClose={setHistoryModal}
            />
          </ModalLyt>
      )}
     </Grid>
     {showToastMessage && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage2 && (
          <DYToastMessage
            isSuccess={iuccess}
            message={tMessage}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
    </>
  )
}

export default MeasurementUnit
